<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/cre.inversionesmartinsas/components/img/help1.png";
import importedImg2 from "@/page/cre.inversionesmartinsas/components/img/help2.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem {
  width: 100%;
  margin: 0;
}

.flexBox:nth-child(2) .imgBox {
  padding-bottom: 20px;
}
</style>
